// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_291_3C4LXY1HOB-EQrckM9","Label":"UD6kLiLxhHYfphyRraOVi","InputWrap":"_3nVWBFHBcVTKLR2l2VtE5K","Button":"_2xTfW6vN3OQiddMWjlsCRf","Input":"_2LPbw--vN3yRjMxADBSPLi","Tag":"_1-QxSFgx5I3RaGx6Y6nljV","CloseIcon":"_3W0NBAzB2kre5msR2w85NZ","Suggestions":"_392FD3r9ezV-w37Ux0fsMt","LockIcon":"_2xf3MzrRZx6i8rn5rvopI5"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/Tags/styles.module.css
// module id = 599
// module chunks = 0